import { render, staticRenderFns } from "./IconSetting.vue?vue&type=template&id=78dfaa51&scoped=true"
import script from "./IconSetting.vue?vue&type=script&lang=js"
export * from "./IconSetting.vue?vue&type=script&lang=js"
import style0 from "./IconSetting.vue?vue&type=style&index=0&id=78dfaa51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dfaa51",
  null
  
)

export default component.exports